/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-03 19:30:49
 * @FilePath: \app-client-h5\src\pages\home\services.js
 */
import http from '../../utils/http';
/**
 * 获取房间信息
 */
 export function getRoomMsg() {
  return http("get", '/my/getRoomInfo');
}
//水费模板
export function getTemplate() {
  return http("get", '/room/usewater/getTemp');
}
//获取token
export function getToken(params) {
  return http("get", '/oauth/token',params);
}



